
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event-gallery/[slug]",
      function () {
        return require("private-next-pages/event-gallery/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event-gallery/[slug]"])
      });
    }
  